import React from 'react'
import { useSelector } from 'react-redux'
import {
    Link as RouterLink,
    useLocation,
} from 'react-router-dom'
import {
    isUriWithChanges as isUriWithChangesSelect
} from './selectors';


const Link = ({
    to,
    children,
    tooltip = null,
    isCustomChildren = false,
}) => {
    const location = useLocation();
    const isMarkedLink = location.pathname?.includes(to) ?? false;
    const linkClass = `list-group-item list-group-item-action sidebar-menu-item${isMarkedLink ? ' marked' : ''}`;

    return (
        <RouterLink
            to={to}
            className={linkClass}
            title={tooltip ?? ''}
        >
            {isCustomChildren
                ? children
                : <span>{children}</span>
            }
        </RouterLink>
    );
}


export const ExclamationLink = ({
    to,
    children,
    tooltip = null,
    isCustomChildren = false,
}) => {
    const location = useLocation();
    const isUriWithChanges = useSelector(isUriWithChangesSelect(to));
    const isMarkedLink = location.pathname?.includes(to) ?? false;
    const linkClass = `list-group-item list-group-item-action sidebar-menu-item${isMarkedLink ? ' marked' : ''}${isUriWithChanges ? ' changes' : ''}`;

    return (
        <RouterLink
            to={to}
            className={linkClass}
            title={`${isUriWithChanges ? 'unsaved changes\n' : ''}${tooltip ?? ''}`}
        >
            {isCustomChildren
                ? children
                : <span>{children}</span>
            }
        </RouterLink>
    );
}


export default Link;